/**
 * ! This component/file or some other components/files that use this component/file is being shared in one or more micro-frontend.
 * ! Please be careful when editing this component. Make sure to run "yarn build:dev" and check if the "build/@types/index.d.ts" file
 * ! is being generated or not without any errors.
 */
import React, { memo } from 'react';

import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';

export interface IControlledErrorProps {
  error: string;
  show: boolean;
  children?: React.ReactNode;
  styleClass?: string;
}

const ControlledError = ({ error, show, children, styleClass = '' }: IControlledErrorProps) => {
  const classes = useStyles();
  return (
    <>
      {children}
      {show && (
        <Typography className={`${styleClass} ${classes.errorMessage} errorMessage`} color="secondary" variant="caption" align="left" component="h1">
          {error}
        </Typography>
      )}
    </>
  );
};

export default memo(ControlledError);
